
import { useEffect } from "react";
import { BrowserRouter } from "react-router-dom";
import { AppRoutes } from "./router";
import { I18nextProvider } from "react-i18next";
import i18n from "./i18n";
import { AuthProvider } from "./contexts/AuthContext";
import ErrorBoundary from "./components/ErrorBoundary";


function App() {
  // Apply theme on app mount - default to dark mode
  useEffect(() => {
    const savedPrefs = localStorage.getItem('systemPreferences');
    let theme = 'dark'; // Default to dark mode
    
    if (savedPrefs) {
      try {
        const parsed = JSON.parse(savedPrefs);
        theme = parsed.theme || 'dark';
      } catch (e) {
        console.error('Failed to load theme');
      }
    } else {
      // Set default preferences with dark theme
      localStorage.setItem('systemPreferences', JSON.stringify({ theme: 'dark' }));
    }
    
    if (theme === 'dark') {
      document.documentElement.classList.add('dark');
    } else if (theme === 'light') {
      document.documentElement.classList.remove('dark');
    } else if (theme === 'auto') {
      const prefersDark = window.matchMedia('(prefers-color-scheme: dark)').matches;
      if (prefersDark) {
        document.documentElement.classList.add('dark');
      } else {
        document.documentElement.classList.remove('dark');
      }
    }
    
    localStorage.setItem('theme', theme);
  }, []);

  return (
    <I18nextProvider i18n={i18n}>
      <ErrorBoundary>
        <AuthProvider>
          <BrowserRouter basename={__BASE_PATH__}>
            <AppRoutes />
          </BrowserRouter>
        </AuthProvider>
      </ErrorBoundary>
    </I18nextProvider>
  );
}

export default App;
